import { AdaptiveUi } from "@avinet/adaptive-ui-core";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./i18n/i18n";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AdaptiveUi theme={theme}>
      <App />
    </AdaptiveUi>
  </React.StrictMode>
);

reportWebVitals();
